"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

require("./Select.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Stateless component to draw a Select
 * @param {string} title Label of the select.
 * @param {string} name name prop of the select tag
 * @param {array} options array of select options (object value and label)
 * @param {object} defaultValue Default value of the select (object value and label)
 * @param {function} send2Form Function used to make this component compatible with JsonSchemaForm
 * @param {function} onChange This function is executed when select change, and rise up the new value to its parent
 * @returns {JSX} Component JSX.
 */
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      var selectedOption = _this.state.selectedOption;

      if (_this.props.send2Form && selectedOption) {
        var name = _this.props.name;
        var value = selectedOption.value;
        var infoGoUp = {
          currentTarget: {
            name: name,
            value: value
          }
        };

        _this.props.send2Form(infoGoUp);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (selectedOption) {
      _this.setState({
        selectedOption: selectedOption,
        error: ''
      });

      if (_this.props.onChange) {
        var name = _this.props.name;
        var value = selectedOption.value;
        var infoGoUp = {
          currentTarget: {
            name: name,
            value: value
          }
        };

        _this.props.onChange(infoGoUp);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.setState(function () {
        return {
          isClick: 'click'
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getValueObjFromValueStr", function (value) {
      var ocurrences = _this.props.options.filter(function (option) {
        return option.value === value;
      });

      if (ocurrences.length === 1) {
        return ocurrences[0];
      }

      return null;
    });

    var isClick = '';

    if (props.defaultValue) {
      isClick = 'click';
    }

    var _selectedOption = _this.getValueObjFromValueStr(props.defaultValue);

    _this.state = {
      isClick: isClick,
      selectedOption: _selectedOption,
      error: props.error
    };
    return _this;
  }

  _createClass(Select, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.error !== nextProps.error) {
        this.setState({
          error: nextProps.error
        });
        return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          name = _this$props.name,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          wrapperClass = _this$props.wrapperClass;
      var error = this.state.error;
      var selectedOption = this.state.selectedOption;
      var validated = true;
      var colorValidation = 'blue';

      if (error && validated === true) {
        colorValidation = 'red';
      } else if (!error && validated === true) {
        colorValidation = 'green';
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "selectWrapper ".concat(wrapperClass)
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: name
      }, title), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
        onClick: this.handleClick,
        id: name,
        name: name,
        options: options,
        isSearchable: false,
        value: selectedOption,
        placeholder: placeholder,
        onChange: this.handleChange,
        className: "react-select-container react-select-container-".concat(colorValidation),
        classNamePrefix: "react-select",
        clearable: true
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "select-highlight"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "select-bar"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "error"
      }, error || "\xA0"));
    }
  }]);

  return Select;
}(_react.Component);

Select.propTypes = {
  title: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  options: _propTypes["default"].array.isRequired,
  error: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  send2Form: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  wrapperClass: _propTypes["default"].string
};
Select.defaultProps = {
  error: '',
  defaultValue: '',
  send2Form: function send2Form() {},
  onChange: function onChange() {},
  placeholder: 'Selecciona una opción',
  wrapperClass: ''
};
var _default = Select;
exports["default"] = _default;

//# sourceMappingURL=index.js.map